<template>
    <component
        :is="is"
        :class="$style.item"
        :to="to"
        :externalTo="externalTo"
        :target="target"
    >
        <Icon
            v-if="iconName"
            :class="$style.highlighted"
            :name="iconName"
        />
        <div :class="$style.column">
            <Typography
                v-if="slots.label"
                :size="labelSize"
                :class="$style.label"
                :responsive="responsive"
                type="label"
            >
                <slot name="label" />
            </Typography>
            <Typography
                v-if="slots.title"
                :size="titleSize"
                :responsive="responsive"
                type="label"
                :class="$style.highlighted"
            >
                <slot name="title" />
            </Typography>
        </div>
    </component>
</template>

<script lang="ts" setup>
import { useSlots } from 'vue'
import { type RouteLocationRaw } from 'vue-router'

import { type IconNameType } from '@/components/Icon'
import Icon from '@/components/Icon/Icon.vue'
import Typography from '@/components/Typography.vue'
import { LinkTarget } from '@/types'
import { type AnyComponent } from '@/types/vue.types'

type ListItemSize = 'xs' | 's' | 'm' | 'l'

defineProps<{
    is: keyof HTMLElementTagNameMap | AnyComponent
    iconName?: IconNameType
    to?: RouteLocationRaw
    externalTo?: string
    target?: LinkTarget
    labelSize: ListItemSize
    titleSize: ListItemSize
    responsive?: boolean
}>()

const slots = useSlots()
</script>

<style module>
.item {
    --transition-duration: 0.15s;

    display: flex;
    flex-direction: row;
    gap: var(--gap-12);
    align-items: center;
    padding: var(--gap-8) 0;
}

.label {
    color: var(--white-40);
    transition: color var(--transition-duration) ease-out;
}

.item:hover .label {
    color: var(--white);
}

.highlighted {
    color: var(--purple-600);
    transition: color var(--transition-duration) ease-out;
}

.item:hover .highlighted,
.item:focus-visible .highlighted {
    color: var(--electric-lime);
}

.column {
    display: flex;
    flex-direction: column;
    gap: var(--gap-4);
    justify-content: center;
}
</style>
